import React from 'react';
import { styled, SvgIcon, Chip } from '@teko/ui';

const Wrapper = styled.div `
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;
const StyledIcon = styled(SvgIcon)(({ theme }) => `
    margin-left: 0.25rem;
    --button-icon-color: ${theme.brand.primary};
  `);
const StyledChip = styled(Chip)(({ theme }) => `
  margin-right: 0.5rem;
  margin-bottom: 0.25rem;
  margin-top: 0.25rem;
  background: ${theme.brand.tertiary} !important;
  color: ${theme.brand.primary};
  border: 1px solid  ${theme.brand.primary};
`);
const ActivatedFilters = ({ activeValues, onClick, }) => {
    if (!activeValues.length)
        return null;
    return (React.createElement(Wrapper, null, activeValues.map((option) => (React.createElement(StyledChip, { onClick: () => onClick && onClick(option), key: option.optionCode },
        React.createElement("span", null, option.optionName),
        React.createElement(StyledIcon, { name: "close", size: 10 }))))));
};

export { ActivatedFilters as A };
